import { createContext, useRef } from 'react';
import cn from 'classnames';

import { IForm } from 'source/NFR.types';

const Context = createContext({ submitForm: () => {} });

interface IFormProps extends IForm {
  className?: string;
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
  showSubmitButton?: boolean;
}

interface IFormComponent extends React.FC<React.PropsWithChildren<IFormProps>> {
  Context: typeof Context;
}

const Form: IFormComponent = ({
  children,
  className,
  endpoint,
  method = 'GET',
  showSubmitButton = true,
  submitButtonText,
  onSubmit
}) => {
  const form = useRef<HTMLFormElement>(null);

  const submitForm = () => {
    form.current?.submit();
  };

  return (
    <form action={endpoint} className={cn('form', className)} method={method} ref={form} onSubmit={onSubmit}>
      <Context.Provider value={{ submitForm }}>{children}</Context.Provider>

      {showSubmitButton && <button type="submit">{submitButtonText}</button>}
    </form>
  );
};

Form.Context = Context;

Form.displayName = 'Form';

export default Form;
